import React from 'react';
import { TEXT } from '../../uiTokens';

/**
 * Left-aligned page intro: optional eyebrow, title, and a short description.
 * `aside` renders to the right of the title on wider screens (e.g. a tag or CTA).
 */
export default function PageHeader({ eyebrow, title, description, aside, className = '' }) {
  return (
    <header className={`flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between ${className}`.trim()}>
      <div className="min-w-0 max-w-prose">
        {eyebrow && <p className={`${TEXT.eyebrowAccent} mb-2.5`}>{eyebrow}</p>}
        <h1 className={TEXT.h1}>{title}</h1>
        {description && <p className={`${TEXT.lead} mt-3 max-w-[52ch]`}>{description}</p>}
      </div>
      {aside && <div className="shrink-0">{aside}</div>}
    </header>
  );
}
